
  import api from "@/api/index"; //ABP API接口
  import {Component, Ref} from "vue-property-decorator";
  import {ElementTableView} from "@/lib/ElementTableView";
  import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
  import AuditUserLogs from "@/components/AuditUserLogs/AuditUserLogs.vue";
  import RefundDetail from "@/views/pays/components/refundDetail.vue";
  import {AuditUserLogType, PayOrderType, RefundDetailDto, RefundLogDto} from "@/api/appService";
  import enumFilter from "@/mixins/filters/enums";
  import AuditFlowDetailButton from "@/components/AuditFlowDetailButton/index.vue";
  import ExportButton from "@/components/ExportButton/index.vue";

  @Component({
  name: "RefundLogList",
  components: {ExportButton, AuditFlowDetailButton, AgileAuditTag, RefundDetail, AuditUserLogs },
  mixins: [enumFilter]
})
export default class RefundLogList extends ElementTableView {
  @Ref() auditUserLogs!: AuditUserLogs;
  tableItems: RefundLogDto[] = [];

  private refundStatus = [
    {
      value: null,
      label: "全部"
    },
    {
      value: true,
      label: "退款成功"
    },
    {
      value: false,
      label: "退款中"
    }
  ];

  async created() {
    await this.fetchData();
  }

  detail: RefundDetailDto = { refundLog: { id: 0 } };
  refundDetailShow: boolean = false;

  dialogShow = false;

  getHostType(log:RefundLogDto){
    if(log.payOrderType === PayOrderType.Activity){
      return AuditUserLogType.ActivityRefund;
    } else if(log.payOrderType === PayOrderType.Card){
      return AuditUserLogType.UserCardRefund;
    } else if(log.payOrderType === PayOrderType.DiffCard){
      return AuditUserLogType.UserCardRefund;
    }

  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.refundLog
      .getAll({
        billNo: this.queryForm.billNo,
        price: this.queryForm.price,
        isSuccess: this.queryForm.isSuccess,
        creationTime: this.queryForm.creationTime,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  async handleView(row: RefundLogDto) {
    await api.refundLog
      .getRefundDetail({ billNo: row.billNo })
      .then(res => {
        console.log(res);
        this.detail = res;
      })
      .finally(() => {
        (this.$refs.refundDetail as any).show = true;
      });
  }

  async handleViewLog(row: RefundLogDto) {
    await api.refundLog
      .getLogs({ id: row.id })
      .then(res => {
        // 日志
        console.log("日志",res);
        if (res.length) {
          this.auditUserLogs.logs = res;
          this.auditUserLogs.show = true;
        } else {
          this.$message.info("没有日志");
        }
      })
      .finally(() => {});
  }

  async handleAgree(row: RefundLogDto) {}

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      billNo: "",
      price: "",
      isSuccess: "",
      creationTime: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }

  //  提交审核
  async handleStartAudit(item: RefundLogDto) {
    await api.refundLog.startAudit({ body: item }).then(res => {
      this.$message.success("已提交");
      this.fetchData();
    });
  }
}
